import React from 'react';

var MentionContent = function MentionContent(_ref) {
  var children = _ref.children;
  return React.createElement(
    'span',
    { style: { backgroundColor: '#e6f3ff' } },
    children
  );
};

export default MentionContent;


//////////////////
// WEBPACK FOOTER
// ./~/rc-editor-mention/es/component/MentionContent.react.js
// module id = 1477
// module chunks = 3